<template>
  <div 
    class="header_table center_block"
    :style="`width: ${width} !important`"
  >
    <div
      class="pointer"
      @click="openMenu"
    >
      {{ name }}
      <ArrowOrder
        class=" mr-3 icon_head_table"
        :field="this.field"
      />
      <font-awesome-icon
        class="right icon_head_table"
        v-if="state.filters[field]"
        icon="filter"
      />
    </div>

    <div
      v-if="state.openWindow == this.field"
      class="card block_filter"
    >
      <div class="f14 card-header">
        Ordernar
        <OrderTable
          :useState="true"
          class="right"
          :entity="entity"
          :field="field"
        />
      </div>
      <div class="card-body pt-1">
        <label class="f14">Filtro</label>
        <input
          v-on:keyup.enter="filter"
          v-model="search_text"
          type="text"
          class="form-control"
        />
        <button
          @click="filter"
          class="btn btn-small mt-1 btn-success left"
        >
          Salvar
        </button>
        <button
          @click="removefilter"
          class="btn btn-small mt-1 btn-danger right"
        >
          Limpar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import OrderTable from "components/OrderTable.vue";
import ArrowOrder from "components/Table/ArrowOrder.vue";
import { state, gettersMap, mutationsMap } from "store/table.js";

export default {
  props: ["name", "entity", "field", "width"],
  components: { OrderTable, ArrowOrder },
  data: () => ({
    open: false,
    state: state,
    search_text: "",
  }),
  mounted() {},
  methods: {
    openMenu() {
      if (gettersMap.getOpenWindow() == this.field) {
        mutationsMap.setOpenWindow("");
        return;
      }
      mutationsMap.setOpenWindow(this.field);
    },
    filter() {
      let filter_field = {};
      filter_field[this.field] = this.search_text;
      mutationsMap.setFilters(filter_field);
      mutationsMap.setOpenWindow("");
    },
    removefilter() {
      mutationsMap.removeFilter(this.field);
      this.search_text = "";
      mutationsMap.setOpenWindow("");
      this.filter();
    },
  },
  watch: {},
};
</script>